import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { CurrentUserViewModel } from "../../core/models/current-user.view-model";
import { AbstractComponent } from "../../core/components/abstract-component";
import { TimelineDataProviderService } from "../../shared/timeline/timeline.data-provider.service";
import { mergeMap } from "rxjs";
import { PostViewModel } from "../../shared/timeline/post.view-model";
import { PostTypeEnum } from "../../core/enums/post-type.enum";
import { TimelineModule } from "../../shared/timeline/timeline.module";
import { TranslateModule } from "@ngx-translate/core";
import { NgIf } from "@angular/common";
import { SeoService } from "../../core/services/seo.service";
import { environment } from "../../../environments/environment";
import { TruncateOnWordPipe } from "../../core/pipes/truncate-on-word.pipe";

@Component({
  selector: 'app-post',
  standalone: true,
  templateUrl: './post.component.html',
  imports: [
    TimelineModule,
    TranslateModule,
    NgIf
  ],
  styleUrls: ['./post.component.css']
})
export class PostComponent extends AbstractComponent implements OnInit, AfterViewInit, OnDestroy {

  public isPlaying = false;
  public currentUser: CurrentUserViewModel;
  public postVM: PostViewModel = new PostViewModel();
  public timelinePosts: PostViewModel[] = [this.postVM];
  public postTypes: PostTypeEnum[] = [PostTypeEnum.SIMPLE_POST, PostTypeEnum.PROJECT_POST, PostTypeEnum.EVENT_DISCUSSION_POST];
  @Input() public asEmbedComponent: boolean = false;
  @Input() public id: string;
  @Input() public fetchDeleted = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly postDPS: TimelineDataProviderService,
    private readonly seo: SeoService
  ) {
    super();
  }

  ngOnInit() {
    this.currentUser = this.route.snapshot.data['currentUser'] || this.route.parent?.snapshot.data['currentUser'];

    if (this.asEmbedComponent && this.id) {
      return this.postDPS.getPost(this.id, this.fetchDeleted).subscribe((postVM: PostViewModel) => {
        this.postVM = postVM;
        this.timelinePosts = [postVM];
      });

    } else {
      this.subscriptions.push(this.route.params.pipe(mergeMap((params: any) => {
        return this.postDPS.getPost(params['id'], this.fetchDeleted);
      })).subscribe((postVM: PostViewModel) => {
        this.postVM = postVM;
        this.timelinePosts = [postVM];
        this.updateSeo();
      }));
    }
  }

  ngAfterViewInit(): void {

  }

  private updateSeo(): void {
    if (!this.postVM || this.postVM.isPlaceholder) {
      return;
    }
    const title = TruncateOnWordPipe.truncateOnWord(this.postVM.content || 'Post', 80, '...');
    const description = TruncateOnWordPipe.truncateOnWord(this.postVM.content || '', 160, '...');
    const url = `${environment.appUrl}/posts/${this.postVM.id}`;
    this.seo.setTitle(title);
    this.seo.setDescription(description);
    this.seo.setOpenGraph({ title, description, url, type: 'article' });
    this.seo.setCanonical(url);
    this.seo.setJsonLd({
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": title,
      "description": description,
      "datePublished": this.postVM.createdAt,
      "dateModified": this.postVM.updatedAt || this.postVM.createdAt,
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": url
      }
    });
  }

}
